module.exports = __webpack_public_path__ + "img/komagatake_rope_way.62425990.jpg";